import { FETCH_LOAD_RECEIPT, FETCH_RECEIVERS_BY_ID } from '../Loads/actionTypes'

import * as types from './actionTypes'

export const initialState = {
  fetchedLoadsDetails: [],
  mappedLoadsDetailsByHash: {},
  auctionBids: {},
  winningBid: null,
  driverToBind: null,
  vehicleToBind: null,
  driverToRegister: null,
  driversToSelect: null,
  deliveryReceipts: {},
  receivers: [],
  logisticOperators: [],
  flEnableTrackingDevice: null,
  pendings: [],
  pendingsTypes: [],
  mappedTrackingDeviceFields: {},
  pendingDrawerVisible: false,
  selectedOrder: null,
  orderIsLoading: false,
}

const formatHash = (hash) => hash && hash.replace(/\W/g, '')

const LoadsDetails = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_LOAD_ATTACHMENTS:
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            attachments: payload.attachments,
            lastUpdatedAt: new Date(),
          },
        },
      }
    case types.MAPPED_TRACKING_DEVICE_FIELDS:
      return {
        ...state,
        mappedTrackingDeviceFields: {
          ...state.mappedTrackingDeviceFields,
          [payload.id]: {
            primary: payload.primary,
            id: [payload.id],
            addTrackingInformation: true,
            justify: '',
          },
        },
      }
    case types.TOGGLE_PENDING_DRAWER_VISIBLE:
      return {
        ...state,
        pendingDrawerVisible: !state.pendingDrawerVisible,
      }
    case types.CLEAR_TRACKING_DEVICE_FIELDS:
      return {
        ...state,
        mappedTrackingDeviceFields: {},
      }
    case types.GET_ALL_PENDINGS_BY_SHIPPING:
      return {
        ...state,
        pendings: payload,
      }
    case types.GET_ALL_PENDINGS_TYPES:
      return {
        ...state,
        pendingsTypes: payload,
      }
    case types.CHANGE_TRACKING_DEVICE_FIELDS:
      return {
        ...state,
        mappedTrackingDeviceFields: {
          ...state.mappedTrackingDeviceFields,
          [payload.id]: {
            ...state.mappedTrackingDeviceFields[payload.id],
            primary: payload.primary,
            id: [payload.id],
            addTrackingInformation: payload.addTracking,
            justify: payload.justify,
          },
        },
      }
    case types.FETCH_LOAD_FILES_BY_ATTACHMENT: {
      return {
        ...state,
        loadFiles: {
          ...state.loadFiles,
          [payload.attachmentId]: payload.files,
        },
      }
    }
    case types.CLEAR_LOAD_FILES_BY_ATTACHMENT: {
      return {
        ...state,
        loadFiles: {
          ...state.loadFiles,
          [payload]: [],
        },
      }
    }
    case FETCH_RECEIVERS_BY_ID:
      return { ...state, receivers: payload }
    case types.FETCH_LOAD_DETAILS:
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...payload,
          },
        },
      }
    case types.FETCH_LOAD_ACCEPTS:
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            accepts: payload.data,
            lastUpdatedAt: new Date(),
          },
        },
      }
    case types.FETCH_LOAD_NEGOTIATIONS:
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            negotiations: payload.data,
            lastUpdatedAt: new Date(),
            negotiationStatus: payload.negotiationStatus,
            estimatedDate: payload.estimatedDate,
            percentMargin: payload.percentMargin,
            negotiationConfig: payload.negotiationConfig,
            negotiationParts: payload.negotiationParts,
            proposalValues: payload.proposalValues,
            flShowOtherPrices: payload.flShowOtherPrices,
          },
        },
      }
    case types.FETCH_LOAD_BIDS:
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            bids: payload.data,
            lastUpdatedAt: new Date(),
          },
        },
      }
    case types.FETCH_LOAD_ITNERARY:
      return {
        ...state,
        trackingOptions: payload.options,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            itinerary: payload.itnerary,
            lastUpdatedAt: new Date(),
          },
        },
      }
    case types.FETCH_LOAD_HISTORY:
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            history: payload.history,
            lastUpdatedAt: new Date(),
          },
        },
      }
    case FETCH_LOAD_RECEIPT: {
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            localReceiptPath: payload.localReceiptPath,
            lastUpdatedAt: new Date(),
          },
        },
      }
    }
    case types.FETCH_LOAD_RECEIPT_BY_DELIVERY: {
      return {
        ...state,
        deliveryReceipts: {
          ...state.deliveryReceipts,
          [payload.destinationId]: payload.receipts,
        },
      }
    }
    case types.CLEAR_DELIVERY_RECEIPTS: {
      return {
        ...state,
        deliveryReceipts: {
          ...state.deliveryReceipts,
          [payload]: [],
        },
      }
    }
    case types.FETCH_LOAD_INCIDENTS:
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            incidents: payload.incidents,
            lastUpdatedAt: new Date(),
          },
        },
      }
    case types.FETCH_INCIDENT_IMAGE:
      return {
        ...state,
        mappedLoadsDetailsByHash: {
          ...state.mappedLoadsDetailsByHash,
          [formatHash(payload.hashId)]: {
            ...state.mappedLoadsDetailsByHash[formatHash(payload.hashId)],
            incidents: payload.incidents,
            lastUpdatedAt: new Date(),
          },
        },
      }
    case types.CLEAR_FOUND_DRIVER:
      return {
        ...state,
        flEnableTrackingDevice: state.flEnableTrackingDevice,
        driversToSelect: null,
        driverToBind: null,
        driverToRegister: null,
      }
    case types.CLEAR_DRIVER_TO_BIND:
      return {
        ...state,
        driverToBind: null,
      }
    case types.CLEAR_VEHICLE_TO_BIND:
      return {
        ...state,
        vehicleToBind: null,
      }
    case types.FIND_DRIVER_BY_CPF:
      return {
        ...state,
        driversToSelect: null,
        driverToBind: payload,
        driverToRegister: null,
      }
    case types.FIND_DRIVER_BY_NAME:
      return {
        ...state,
        driversToSelect: payload,
        driverToRegister: null,
        driverToBind: null,
      }
    case types.FIND_DRIVER_BY_NAME_NOT_FOUND:
      return {
        ...state,
        driversToSelect: 'NOT_FOUND',
        driverToRegister: null,
        driverToBind: null,
      }
    case types.FIND_DRIVER_BY_CPF_TO_REGISTER:
      return {
        ...state,
        driverToRegister: payload,
        driverToBind: null,
        driversToSelect: null,
      }
    case types.FIND_VEHICLE_BY_PLATE:
      return {
        ...state,
        vehicleToBind: payload,
      }
    case types.FETCH_LOGISTIC_OPERATORS:
      return {
        ...state,
        logisticOperators: payload,
      }
    case types.HANDLE_ENABLE_TRACKING_DEVICE:
      return {
        ...state,
        ...payload,
      }
    case types.ORDER_IS_LOADING:
      return {
        ...state,
        orderIsLoading: payload,
      }
    case types.SELECT_ORDER_BY_CODE:
      return {
        ...state,
        selectedOrder: payload,
      }
    default:
      return state
  }
}

export default LoadsDetails
